// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 854 ? "pdfjs" : chunkId) + "." + {"854":"b79e2018","967":"ac42e975"}[chunkId] + ".chunk.js";
};